<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'PolicyServicing' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Policy Servicing</h2>
              <p class="listing-page-desc text-capitalize">{{ type.toLowerCase().split("_").join(" ") }} request</p>

            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
        <div class="row mb-4">
          <div class="col-12 ib-border-b">
            <ul class="list-inline">
              <li class="mb-3 mb-md-0"><h1 class="ib-claim-listing text-capitalize">{{ type.toLowerCase().split("_").join(" ") }} Details</h1></li>
            </ul>
          </div>
          <div class="container mt-3">
            <form v-if="type == 'cancellation'" v-on:submit="cancellationRequest" >
               <div class="row">
                 <div class="col-md-6 px-0 px-sm-3">
                   <label>Reason<span>*</span>
                   </label>
                   <div class="jbl-field">
                     <textarea name="food_crops" required placeholder="Enter Cancellation Reason" class="jbl-dynamic-input" v-model="values.reason"></textarea>
                   </div>
                 </div>
               </div>
              <div class="field jbl-responsive-btn">
                <input type="submit" class="ib-btn-primary ib-btn-width ib-btn-hover" value="Submit">
              </div>
            </form>


            <div v-if="type == 'beneficiary' && !isBeneficiaryFound" >
              <h2 class="documents-heading">Old Detail</h2>
              <div class="row">
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name')[0].visible">
                  <label>First Name<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input disabled class="jbl-dynamic-input" type="text" name="first_name" v-model="OldBeneficiary.first_name" :placeholder="'Enter First Name'" required>
                  </div>

                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name')[0].visible">
                  <label>Last Name<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input disabled class="jbl-dynamic-input" type="text" name="last_name" v-model="OldBeneficiary.last_name" :placeholder="'Enter Last Name'" required>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob')[0].visible">
                  <label>Date of Birth<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob')[0].required">*</span></label>
                  <div class="jbl-field">
                    <datepicker disabled initial-view="year" class="jbl-dynamic-input" name="beneficiary_dob" v-model="OldBeneficiary.dob" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar" required></datepicker>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender')[0].visible">
                  <div>
                    <label>Gender<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender')[0].required">*</span></label>
                    <select disabled style="width: 100% !important;" class="floating-select" v-model="OldBeneficiary.gender">
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                    <span class="highlight"></span>
                    <div class="ib-custom-select"></div>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic')[0].visible">
                  <label>CNIC<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input disabled class="jbl-dynamic-input" type="text" name="cnic" v-model="OldBeneficiary.cnic" v-mask="'#####-#######-#'" :placeholder="'Enter CNIC'">
                  </div>

                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date')[0].visible">
                  <label>CNIC Issue Date<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date')[0].required">*</span></label>
                  <div class="jbl-field">
                    <datepicker disabled initial-view="year" class="jbl-dynamic-input" name="cnic_issue_date" v-model="OldBeneficiary.cnic_issue_date" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                  </div>

                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date')[0].visible">
                  <label>CNIC Expiry Date<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date')[0].required">*</span></label>
                  <div class="jbl-field">
                    <datepicker disabled initial-view="year" class="jbl-dynamic-input" name="cnic_expiry_date" v-model="OldBeneficiary.cnic_expiry_date" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                  </div>


                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no')[0].visible">
                  <label>Mobile Number<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input disabled class="jbl-dynamic-input" type="text" name="mobile_no" v-model="OldBeneficiary.mobile_no" v-mask="'+923#########'"
                           @change="validateBeneficiaryMobileNo($event)" :placeholder="'Enter Mobile Number'">
                  </div>


                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email')[0].visible">
                  <label>Email<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input disabled class="jbl-dynamic-input" type="email" name="email" v-model="OldBeneficiary.email" :placeholder="'Enter Email'"
                           @change="verifyBeneficiaryEmail($event)">
                  </div>


                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship')[0].visible">
                  <div>
                    <label>Relationship<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship')[0].required">*</span></label>
                    <select disabled style="width: 100% !important;" class="floating-select" name="relationship" v-model="OldBeneficiary.relation_id"
                            onchange="this.setAttribute('value', this.value);" v-if="beneficiaries.relationship">
                      <option value="">Select Relationship</option>
                      <option v-for="(beneficiaryRelation, index) in beneficiaryRelations" :value="beneficiaryRelation.id" :key="index">{{beneficiaryRelation.name}}</option>
                    </select>
                    <select disabled style="width: 100% !important;" class="floating-select" name="relationship" v-model="OldBeneficiary.relation_id"
                            onchange="this.setAttribute('value', this.value);" v-else value="">
                      <option value="">Select Relationship</option>
                      <option v-for="(beneficiaryRelation, index) in beneficiaryRelations" :value="beneficiaryRelation.id" :key="index">{{beneficiaryRelation.name}}</option>
                    </select>
                    <span class="highlight"></span>
                    <div class="ib-custom-select"></div>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address')[0].visible">
                  <label>Address<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address')[0].required">*</span></label>
                  <div class="jbl-field">
                    <textarea disabled class="jbl-dynamic-input" v-model="OldBeneficiary.address" name="address" :placeholder="'Enter Address'"></textarea>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3">
                  <label>Reason<span>*</span></label>
                  <div class="jbl-field">
                    <textarea v-model="values.reason" required class="jbl-dynamic-input" name="address" :placeholder="'Enter Reason'"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <form v-if="type == 'beneficiary' && !isBeneficiaryFound" v-on:submit="BeneficiaryRequest" id="BeneficiaryRequest">
              <h2 class="documents-heading">New Detail</h2>
              <div class="row">
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name')[0].visible">
                  <label>First Name<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input class="jbl-dynamic-input" type="text" name="first_name" v-model="beneficiaries['first_name']" :placeholder="'Enter First Name'" required>
                  </div>

                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name')[0].visible">
                  <label>Last Name<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input class="jbl-dynamic-input" type="text" name="last_name" v-model="beneficiaries['last_name']" :placeholder="'Enter Last Name'" required>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob')[0].visible">
                  <label>Date of Birth<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob')[0].required">*</span></label>
                  <div class="jbl-field">
                    <datepicker initial-view="year" class="jbl-dynamic-input" name="beneficiary_dob" v-model="beneficiaries['dob']" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar" required></datepicker>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender')[0].visible">
                  <div>
                    <label>Gender<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender')[0].required">*</span></label>
                    <select style="width: 100% !important;" class="floating-select" v-model="beneficiaries['gender']" required>
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                    <span class="highlight"></span>
                    <div class="ib-custom-select"></div>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic')[0].visible">
                  <label>CNIC<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input required class="jbl-dynamic-input" type="text" name="cnic" v-model="beneficiaries['cnic']" v-mask="'#####-#######-#'" :placeholder="'Enter CNIC'">
                  </div>

                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date')[0].visible">
                  <label>CNIC Issue Date<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date')[0].required">*</span></label>
                  <div class="jbl-field">
                    <datepicker required initial-view="year" class="jbl-dynamic-input" name="cnic_issue_date" v-model="beneficiaries['cnic_issue_date']" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                  </div>

                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date')[0].visible">
                  <label>CNIC Expiry Date<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date')[0].required">*</span></label>
                  <div class="jbl-field">
                    <datepicker required initial-view="year" class="jbl-dynamic-input" name="cnic_expiry_date" v-model="beneficiaries['cnic_expiry_date']" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                  </div>


                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no')[0].visible">
                  <label>Mobile Number<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input required class="jbl-dynamic-input" type="text" name="mobile_no" v-model="beneficiaries['mobile_no']" v-mask="'+923#########'"
                           @change="validateBeneficiaryMobileNo($event)" :placeholder="'Enter Mobile Number'">
                  </div>


                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email')[0].visible">
                  <label>Email<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email')[0].required">*</span></label>
                  <div class="jbl-field">
                    <input required class="jbl-dynamic-input" type="email" name="email" v-model="beneficiaries['email']" :placeholder="'Enter Email'"
                           @change="verifyBeneficiaryEmail($event)">
                  </div>


                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship')[0].visible">
                  <div>
                    <label>Relationship<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship')[0].required">*</span></label>
                    <select required style="width: 100% !important;" class="floating-select" name="relationship" v-model="OldBeneficiary.relation_id"
                            onchange="this.setAttribute('value', this.value);" v-if="beneficiaries.relationship" >
                      <option value="">Select Relationship</option>
                      <option v-for="(beneficiaryRelation, index) in beneficiaryRelations" :value="beneficiaryRelation.id" :key="index">{{beneficiaryRelation.name}}</option>
                    </select>
                    <select required style="width: 100% !important;" class="floating-select" name="relationship" v-model="beneficiaries['relation_id']"
                            onchange="this.setAttribute('value', this.value);" v-else>
                      <option value="">Select Relationship</option>
                      <option v-for="(beneficiaryRelation, index) in beneficiaryRelations" :value="beneficiaryRelation.id" :key="index">{{beneficiaryRelation.name}}</option>
                    </select>
                    <span class="highlight"></span>
                    <div class="ib-custom-select"></div>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3" v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address')[0].visible">
                  <label>Address<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address')[0].required">*</span></label>
                  <div class="jbl-field">
                    <textarea required class="jbl-dynamic-input" v-model="beneficiaries['address']" name="address" :placeholder="'Enter Address'"></textarea>
                  </div>
                </div>
                <div class="col-md-6 px-0 px-sm-3">
                  <label>Reason<span>*</span></label>
                  <div class="jbl-field">
                    <textarea v-model="values.reason" required class="jbl-dynamic-input" name="address" :placeholder="'Enter Reason'"></textarea>
                  </div>
                </div>
              </div>
              <div class="field jbl-responsive-btn">
                <input type="submit" class="ib-btn-primary ib-btn-width ib-btn-hover" value="Submit">
              </div>
              <div v-if="isBeneficiaryFound">
                <h2 style="color: #C6C6C6">No Beneficiary Found Against This Policy</h2>
              </div>
            </form>

            <div v-if="type == 'family'">
              <button @click="AddFamilyModal()" v-if="familyConfig.family.family_action == 'add'" class="btn ib-btn-outline"><i class="fa fa-plus" aria-hidden="true"></i> Add Member</button>

              <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                <div class="container-fluid">
                  <div class="container ib-p-0">
                    <div class="container mt-5">
                      <div class="panel panel-default" >
                        <div v-for="(familyMember, index) in familyMembers" :key="'member_' + index" :id="'member_' + familyMember.id">
                          <div class="panel-heading active" role="tab" :id="'headingOne' + index">
                            <div class="collapsible-link">
                              <a role="button" data-toggle="collapse" data-parent="#accordion"  :href="'#mainClassesProductsAccordion' + index" aria-expanded="false" :aria-controls="'mainClassesProductsAccordion' + index">
                                Member <b>{{ familyMember.relation }}</b>
                                  <span class="plus-icon">&plus;</span>
                                  <span class="minus-icon">&minus;</span>
                              </a>
                            </div>
                          </div>
                          <div :id="'mainClassesProductsAccordion' + index" class="panel-collapse collapse in" role="tabpanel">
                            <div class="panel-body">
                              <span class="in-policy-action in-policy-action--delete" @click="setDeletedId(familyMember.id, familyMember.relation)" v-if="familyConfig.family.family_action == 'remove'"><i class="fa fa-trash" aria-hidden="true"></i></span>
                              <span class="in-policy-action" @click="ShowEditForm(familyMember.id)" v-if="familyConfig.family.family_action == 'update'"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                              <table class="table table-borderless">
                                <tr>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">Name</p>
                                    <dd class="claim-row-data">{{ familyMember.name }}</dd>
                                  </td>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">CNIC</p>
                                    <dd class="claim-row-data">{{ familyMember.cnic }}</dd>
                                  </td>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">DOB</p>
                                    <dd class="claim-row-data">{{ familyMember.dob }}</dd>
                                  </td>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">Passport</p>
                                    <dd class="claim-row-data">{{ familyMember.passport }}</dd>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">Relation</p>
                                    <dd class="claim-row-data">{{ familyMember.relation }}</dd>
                                  </td>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">Gender</p>
                                    <dd class="claim-row-data">{{ familyMember.gender }}</dd>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div v-for="(familyMember, index) in saveFamilyMembers" :key="'member' + index" v-if="familyConfig.family.family_action == 'add'" :id="'member_' + familyMember.id">
                          <div class="panel-heading active" role="tab" :id="'headingOne' + index">
                            <div class="collapsible-link">
                              <a role="button" data-toggle="collapse" data-parent="#accordion"  :href="'#mainClassesProductsAccordion_' + index" aria-expanded="false" :aria-controls="'mainClassesProductsAccordion' + index">
                               New Member <b>{{ familyMember.relation }}</b>
                                  <span class="plus-icon">&plus;</span>
                                  <span class="minus-icon">&minus;</span>
                              </a>
                              <!-- <button @click="rmsaveNewFamily(familyMember.id)" ><i class="fa fa-trash" aria-hidden="true"></i></button>
                              <button @click="showUpdateForm(familyMember.id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button> -->

                            </div>
                          </div>
                          <div :id="'mainClassesProductsAccordion_' + index" class="panel-collapse collapse in" role="tabpanel">
                            <div class="panel-body">
                               <!-- @click="rmsaveNewFamily(familyMember.id)" -->
                              <span class="in-policy-action in-policy-action--delete" @click="rmsaveNewFamily(familyMember.id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                               <!-- @click="showUpdateForm(familyMember.id)" -->
                              <span class="in-policy-action" @click="showUpdateForm(familyMember.id)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                              <table class="table table-borderless">
                                <tr>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">Name</p>
                                    <dd class="claim-row-data">{{ familyMember.name }}</dd>
                                  </td>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">CNIC</p>
                                    <dd class="claim-row-data">{{ familyMember.cnic }}</dd>
                                  </td>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">DOB</p>
                                    <dd class="claim-row-data">{{ familyMember.dob }}</dd>
                                  </td>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">Passport</p>
                                    <dd class="claim-row-data">{{ familyMember.passport }}</dd>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">Relation</p>
                                    <dd class="claim-row-data">{{ familyMember.relation }}</dd>
                                  </td>
                                  <td>
                                    <p class="claim-row-data claim-row-sub-heading">Gender</p>
                                    <dd class="claim-row-data">{{ familyMember.gender }}</dd>
                                  </td>
                                </tr>
                              </table>
                              <!-- <div class="responsive-flex">
                                <div class="row">
                                    <div class="col-md-4">
                                       <b>Name:</b>
                                      {{ familyMember.name }}
                                    </div>
                                    <div class="col-md-4">
                                       <b>CNIC:</b>
                                      {{ familyMember.cnic }}
                                    </div>
                                    <div class="col-md-4">
                                       <b>DOB:</b>
                                      {{ familyMember.dob }}
                                    </div>
                                    <div class="col-md-4">
                                       <b>Passport:</b>
                                      {{ familyMember.passport }}
                                    </div>
                                    <div class="col-md-4">
                                       <b>Relation:</b>
                                      {{ familyMember.relation }}
                                    </div>
                                    <div class="col-md-4">
                                       <b>Gender:</b>
                                      {{ familyMember.gender }}
                                    </div>
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
<!--                      <div class="col-md-12">-->
<!--                        <div>-->
<!--                          <label>Reason<span>*</span></label>-->
<!--                          <div class="jbl-field">-->
<!--                            <textarea v-model="values.reason" required class="jbl-dynamic-input" name="address" :placeholder="'Enter Reason'"></textarea>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                    </div>

                    </div>
                  </div>
                </div>
              </div>


              <div class="field jbl-responsive-btn">
                <input type="submit" class="ib-btn-primary ib-btn-width ib-btn-hover" @click="UpdateFamily" value="Submit">
              </div>
            </div>

            <div v-if="type == 'general_acquisition'">
              <h2  class="documents-heading">Old Detail</h2>
              <form>
                <div class="row">
                  <div v-for="(field, index) in OldAcquisitionDynamicFields.custom_fields" :key="index" class="col-md-6 px-0 px-sm-3">
                    <div class="ib-dropdown-error" v-if="field.type.toLowerCase() == 'dropdown'">
                      <div>
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <select disabled style="width: 100% !important;" class="floating-select" :name="field.field_name" v-model="OldstepOneDynamicFields[field.field_name]" @change="getStepOneChildData(field)">
                          <option value="">{{field.label.length < 40 ? field.label : 'Select'}}</option>
                          <option v-for="(value, index) in field.default_values" :value="value.id" :key="index">{{value.text}}</option>
                        </select>
                        <span class="highlight"></span>
                        <div class="ib-custom-select"></div>
                      </div>

                    </div>

                    <div class="" v-else-if="field.type.toLowerCase() == 'textbox'">
                      <div v-if="field.inputType.toLowerCase() === 'number'">
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input disabled class="jbl-dynamic-input" @change="verifyStepOneNumbers($event, field.field_name)" type="text" :name="field.field_name"
                                v-model="OldstepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                      <div v-else-if="field.inputType.toLowerCase() === 'mobile'">
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input disabled class="jbl-dynamic-input" type="text" :name="field.field_name" v-mask="'+92##########'"
                                v-model="OldstepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                      <div v-else-if="field.inputType.toLowerCase() === 'email'">
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input disabled class="jbl-dynamic-input" @keyup="verifyStepOneEmail($event, field.field_name)" type="email" :name="field.field_name"
                                v-model="OldstepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                      <div v-else-if="field.inputType.toLowerCase() === 'cnic'">
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input disabled class="jbl-dynamic-input" type="text" :name="field.field_name" v-mask="'#####-#######-#'"
                                v-model="OldstepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                      <div v-else>
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input disabled class="jbl-dynamic-input" :type="field.type" :name="field.field_name" v-model="OldstepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                    </div>

                    <div v-else-if="field.type.toLowerCase() == 'radiobutton'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                      <div class="list-inline" style="padding-left:7px;">
                        <div class="list-inline-item mr-5" v-for="(value, index) in field.default_values" :key="index" :for="field.field_name + value.id" style="font-size:14px !important; color:gray;">
                          <span style="position: relative; left: 2px;">{{value.text}}</span>
                          <label class="ib-radio-container" :for="field.field_name + value.id" style="font-size:14px !important; padding-top: 2px;">
                            <input disabled class="" :value="value.id" type="radio" :name="field.field_name" :id="field.field_name + value.id" v-model="OldstepOneDynamicFields[field.field_name]">
                            <span class="radio-checkmark"></span>
                          </label>
                        </div>
                      </div>

                    </div>

                    <div class="" v-else-if="field.type.toLowerCase() == 'checkbox'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                      <div v-for="(value, index) in field.default_values" :key="index">
                        <input disabled class="" :value="value.id" type="checkbox" :name="field.field_name" :id="field.field_name + value.id" v-model="OldstepOneDynamicFields[field.field_name]">
                        <label :for="field.field_name + value.id">{{value.text}}</label>
                      </div>
                    </div>

                    <div class="" v-else-if="field.type.toLowerCase() == 'datetime'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                      <div class="jbl-field">
                        <datepicker disabled initial-view="year" class="jbl-dynamic-input" :name="field.field_name" v-model="OldstepOneDynamicFields[field.field_name]" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                      </div>

                    </div>

                    <div class="" v-else-if="field.type.toLowerCase() == 'date'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                      <div class="jbl-field">
                        <datepicker disabled initial-view="year" class="jbl-dynamic-input" :name="field.field_name" v-model="OldstepOneDynamicFields[field.field_name]" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                      </div>

                    </div>

                    <div v-else-if="field.type.toLowerCase() == 'textarea'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                      <div class="jbl-field">
                        <textarea disabled class="jbl-dynamic-input" v-model="OldstepOneDynamicFields[field.field_name]" :name="field.field_name" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 px-0 px-sm-3">
                    <label>Reason<span>*</span></label>
                    <div class="jbl-field">
                      <textarea v-model="values.reason" required class="jbl-dynamic-input" name="address" :placeholder="'Enter Reason'"></textarea>
                    </div>
                  </div>
                </div>

<!--                <div v-for="(element, index) in stepThreeDocumentSections" :key="element.field_name">-->
<!--                  <div>-->
<!--                    <h4 class="ib-upload-heading">{{element.label}}<span v-if="element.required"> *</span></h4>-->
<!--                  </div>-->
<!--                  <div class="container">-->
<!--                    <div class="row text-center ib-default-flex">-->
<!--                      <div class="col-md-6 order-last order-md-first" v-for="(image, index) in stepThreeDynamicDocuments[element.field_name]" :key="image.name">-->
<!--                        <div class="document-list">-->
<!--                          <div class="">-->
<!--                          <span>-->
<!--                            <img class="doc-remove-icon" :src="require('@/assets/images/ib-upload-remove-icon.svg')" @click="removeStepThreeUploadedImage(index, element.field_name)">-->
<!--                          </span>-->
<!--                          </div>-->
<!--                          <span class="document-list-title"><img :src="require('@/assets/images/text-document.svg')"> {{image.name}}</span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div key="key1" class="col-10 col-sm-8 col-md-10 col-lg-6 mx-auto ml-md-0 order-first order-md-last">-->
<!--                        <label class="" :for="index">-->
<!--                          <div class="">-->
<!--                            <div class="ib-upload-btn">-->
<!--                              <div class="jbl-browse-text"></div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </label>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="in-mbody-footer">-->
<!--                  <button class="ib-btn-primary ib-btn-hover mr-3" type="submit">Update</button>-->
<!--                </div>-->
              </form>
              <h2 class="documents-heading">New Detail</h2>
              <form v-on:submit="generalAcquisitionForm" id="generalAcquisition">

                <div class="row">
                  <div v-for="(field, index) in AcquisitionDynamicFields.custom_fields" :key="index" class="col-md-6 px-0 px-sm-3">
                    <div class="ib-dropdown-error" v-if="field.type.toLowerCase() == 'dropdown'">
                      <div>
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <select style="width: 100% !important;" class="floating-select" :name="field.field_name" v-model="stepOneDynamicFields[field.field_name]" @change="getStepOneChildData(field)">
                          <option value="">{{field.label.length < 40 ? field.label : 'Select'}}</option>
                          <option v-for="(value, index) in field.default_values" :value="value.id" :key="index">{{value.text}}</option>
                        </select>
                        <span class="highlight"></span>
                        <div class="ib-custom-select"></div>
                      </div>

                    </div>

                    <div class="" v-else-if="field.type.toLowerCase() == 'textbox'">
                      <div v-if="field.inputType.toLowerCase() === 'number'">
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input class="jbl-dynamic-input" @change="verifyStepOneNumbers($event, field.field_name)" type="text" :name="field.field_name"
                                v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                      <div v-else-if="field.inputType.toLowerCase() === 'mobile'">
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input class="jbl-dynamic-input" :id="field.field_name" @keyup="validateStepOneMobileNo($event, field.field_name)" type="text" :name="field.field_name" v-mask="'+92##########'"
                                v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                      <div v-else-if="field.inputType.toLowerCase() === 'email'">
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input class="jbl-dynamic-input" @keyup="verifyStepOneEmail($event, field.field_name)" type="email" :name="field.field_name"
                                v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                      <div v-else-if="field.inputType.toLowerCase() === 'cnic'">
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input class="jbl-dynamic-input" type="text" :name="field.field_name" v-mask="'#####-#######-#'"
                                v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                      <div v-else>
                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                        <div class="jbl-field">
                          <input class="jbl-dynamic-input" :type="field.type" :name="field.field_name" v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                        </div>

                      </div>
                    </div>

                    <div v-else-if="field.type.toLowerCase() == 'radiobutton'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                      <div class="list-inline" style="padding-left:7px;">
                        <div class="list-inline-item mr-5" v-for="(value, index) in field.default_values" :key="index" :for="field.field_name + value.id" style="font-size:14px !important; color:gray;">
                          <span style="position: relative; left: 2px;">{{value.text}}</span>
                          <label class="ib-radio-container" :for="field.field_name + value.id" style="font-size:14px !important; padding-top: 2px;">
                            <input class="" :value="value.id" type="radio" :name="field.field_name" :id="field.field_name + value.id" v-model="stepOneDynamicFields[field.field_name]">
                            <span class="radio-checkmark"></span>
                          </label>
                        </div>
                      </div>

                    </div>

                    <div class="" v-else-if="field.type.toLowerCase() == 'checkbox'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                      <div v-for="(value, index) in field.default_values" :key="index">
                        <input class="" :value="value.id" type="checkbox" :name="field.field_name" :id="field.field_name + value.id" v-model="stepOneDynamicFields[field.field_name]">
                        <label :for="field.field_name + value.id">{{value.text}}</label>
                      </div>

                    </div>

                    <div class="" v-else-if="field.type.toLowerCase() == 'datetime'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                      <div class="jbl-field">
                        <datepicker initial-view="year" class="jbl-dynamic-input" :name="field.field_name" v-model="stepOneDynamicFields[field.field_name]" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                      </div>

                    </div>

                    <div class="" v-else-if="field.type.toLowerCase() == 'date'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                      <div class="jbl-field">
                        <datepicker initial-view="year" @keyup="CheckDate($event, field.field_name)" class="jbl-dynamic-input" :name="field.field_name" v-model="stepOneDynamicFields[field.field_name]" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                      </div>

                    </div>

                    <div v-else-if="field.type.toLowerCase() == 'textarea'">
                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                      <div class="jbl-field">
                        <textarea class="jbl-dynamic-input" v-model="stepOneDynamicFields[field.field_name]" :name="field.field_name" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 px-0 px-sm-3">
                    <label>Reason<span>*</span></label>
                    <div class="jbl-field">
                      <textarea v-model="values.reason" required class="jbl-dynamic-input" name="address" :placeholder="'Enter Reason'"></textarea>
                    </div>
                  </div>
                </div>

                <div v-for="(element, index) in stepThreeDocumentSections" :key="element.field_name">
                  <div>
                    <h4 class="ib-upload-heading">{{element.label}}<span v-if="element.required"> *</span></h4>
                  </div>
                  <div class="container">
                    <div class="row text-center ib-default-flex">
                      <div class="col-md-6 order-last order-md-first" v-for="(image, index) in stepThreeDynamicDocuments[element.field_name]" :key="image.name">
                        <div class="document-list">
                          <div class="">
                          <span>
                            <img class="doc-remove-icon" :src="require('@/assets/images/ib-upload-remove-icon.svg')" @click="removeStepThreeUploadedImage(index, element.field_name)">
                          </span>
                          </div>
                          <span class="document-list-title"><img :src="require('@/assets/images/text-document.svg')"> {{image.name}}</span>
                        </div>
                      </div>
                      <div key="key1" class="col-10 col-sm-8 col-md-10 col-lg-6 mx-auto ml-md-0 order-first order-md-last">
                        <label class="" :for="index">
                          <div class="">
                            <div class="ib-upload-btn">
                              <div class="jbl-browse-text"></div>
                            </div>
                          </div>
                        </label>

                        <input style="display: none" :name="element.field_name" :id="index"
                               type="file"
                               multiple
                               accept="image/*"
                               @change="uploadStepThreeImages($event, element.field_name, element.max_rule)"
                               onclick="this.value=null"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="in-mbody-footer">
                  <button class="ib-btn-primary ib-btn-hover ib-btn-width mr-3" type="submit">Update</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" v-bind:class="[ addFamily ? 'd-block' : 'd-none' ]" id="addFamily" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="jbl-m-inner">
            <div class="modal-header">
              <h5 class="jbl-m-title" id="whyBuyModalTitle">Edit Family Member </h5>
              <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
              <img class="img-fluid" @click="CloseModal()" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
            </span>
            </div>
            <div class="modal-body">
              <div class="modal-body login-modal-body in-scroll-body" style="min-height: 500px;" v-if="selectedMember.relation == 'child'">
                <form v-on:submit="saveFamily">
                  <div v-if="familyConfig.allowed_fields.child.includes('name')">
                    <label class="jbl-dynamic-label">Name<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="modelFamily.child.name" placeholder="Enter Name"/>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.child.includes('cnic')">
                    <label class="jbl-dynamic-label">CNIC<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="modelFamily.child.cnic" placeholder="Enter CNIC" v-mask="'#####-#######-#'"/>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.child.includes('dob')">
                    <label class="jbl-dynamic-label">Date of Birth<span>*</span></label>
                    <div class="jbl-field">
                      <datepicker initial-view="year" class="jbl-dynamic-input" name="family_dob" v-model="modelFamily.child.dob" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.child.includes('passport')">
                    <label class="jbl-dynamic-label">Passport Number<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="modelFamily.child.passport" placeholder="Enter Passport Number"/>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.child.includes('relationship')">
                    <div>
                      <label>Relationship<span>*</span></label>
                      <select style="width: 100% !important;" class="floating-select" v-model="modelFamily.child.relationship">
                        <option value="">Select Relationship</option>
                        <option value="spouse">Spouse</option>
                        <option value="child">Child</option>
                      </select>
                      <span class="highlight"></span>
                      <div class="ib-custom-select"></div>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.child.includes('gender')">
                    <div>
                      <label>Gender<span>*</span></label>
                      <select style="width: 100% !important;" class="floating-select" v-model="modelFamily.child.gender">
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </select>
                      <span class="highlight"></span>
                      <div class="ib-custom-select"></div>
                    </div>
                  </div>
                  <div class="in-mbody-footer">
                    <button class="ib-btn-primary ib-btn-hover mr-3" type="submit">Save</button>
                  </div>
                </form>
              </div>

              <div class="modal-body login-modal-body in-scroll-body" style="min-height: 500px;" v-if="selectedMember.relation == 'spouse'">
                <form v-on:submit="saveFamily" id="EditFamily">
                  <div v-if="familyConfig.allowed_fields.spouse.includes('name')">
                    <label class="jbl-dynamic-label">Name<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="modelFamily.spouse.name" placeholder="Enter Name"/>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.spouse.includes('cnic')">
                    <label class="jbl-dynamic-label">CNIC<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="modelFamily.spouse.cnic" placeholder="Enter CNIC" v-mask="'#####-#######-#'"/>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.spouse.includes('dob')">
                    <label class="jbl-dynamic-label">Date of Birth<span>*</span></label>
                    <div class="jbl-field">
                      <datepicker initial-view="year" class="jbl-dynamic-input" name="family_dob" v-model="modelFamily.spouse.dob" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                    </div>
                    <span style="color: red"><small>{{ familyDobValidation }}</small></span>
                  </div>

                  <div v-if="familyConfig.allowed_fields.spouse.includes('passport')">
                    <label class="jbl-dynamic-label">Passport Number<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="modelFamily.spouse.passport" placeholder="Enter Passport Number"/>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.spouse.includes('relationship')">
                    <div>
                      <label>Relationship<span>*</span></label>
                      <select style="width: 100% !important;" class="floating-select" v-model="modelFamily.spouse.relationship">
                        <option value="">Select Relationship</option>
                        <option value="spouse">Spouse</option>
                        <option value="child">Child</option>
                      </select>
                      <span class="highlight"></span>
                      <div class="ib-custom-select"></div>
                    </div>

                  </div>

                  <div v-if="familyConfig.allowed_fields.spouse.includes('gender')">
                    <div>
                      <label>Gender<span>*</span></label>
                      <select style="width: 100% !important;" class="floating-select" v-model="modelFamily.spouse.gender">
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </select>
                      <span class="highlight"></span>
                      <div class="ib-custom-select"></div>
                    </div>
                  </div>
                  <div class="in-mbody-footer">
                    <button class="ib-btn-primary ib-btn-hover mr-3" type="Submit">Save</button>
                  </div>
                </form>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" v-bind:class="[ showFamily ? 'd-block' : 'd-none' ]" id="showFamily" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content" style="max-height: 600px; overflow-x: hidden; overflow-y: scroll;">
          <div class="jbl-m-inner">
            <div class="modal-header">
              <h5 class="jbl-m-title" id="whyBuyModalTitles">Add Family Member</h5>
              <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                                  <!-- &times; -->
              <img class="img-fluid" @click="CloseModal()" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
            </span>
            </div>
            <div>
              <div class="modal-body login-modal-body in-scroll-body" style="min-height: 500px;" >
                <form v-on:submit="saveNewFamily">
                  <div>
                    <label class="jbl-dynamic-label">Name<span>*</span></label>
                    <div class="jbl-field">
                      <input required class="jbl-dynamic-input" type="text" v-model="addFamilyModel.name" placeholder="Enter Name"/>
                    </div>

                  </div>

                  <div>
                    <label class="jbl-dynamic-label">CNIC<span>*</span></label>
                    <div class="jbl-field">
                      <input required class="jbl-dynamic-input" type="text" v-model="addFamilyModel.cnic" placeholder="Enter CNIC" v-mask="'#####-#######-#'"/>
                    </div>

                  </div>

                  <div >
                    <label class="jbl-dynamic-label">Date of Birth<span>*</span></label>
                    <div class="jbl-field">
                      <datepicker required initial-view="year" class="jbl-dynamic-input" name="family_dob" v-model="addFamilyModel.dob" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                    </div>
                    <span style="color: red"><small>{{ familyDobValidation }}</small></span>
                  </div>

                  <div >
                    <label class="jbl-dynamic-label">Passport Number<span>*</span></label>
                    <div class="jbl-field">
                      <input required class="jbl-dynamic-input" type="text" v-model="addFamilyModel.passport" placeholder="Enter Passport Number"/>
                    </div>

                  </div>
                  <input type="hidden" v-model="addFamilyModel.id">
                  <div>
                    <div>
                      <label>Relationship<span>*</span></label>
                      <select required style="width: 100% !important;" class="floating-select" v-model="addFamilyModel.relation">
                        <option value="">Select Relationship</option>
                        <option value="spouse">Spouse</option>
                        <option value="child">Child</option>
                      </select>
                      <span class="highlight"></span>
                      <div class="ib-custom-select"></div>
                    </div>

                  </div>

                  <div>
                    <div>
                      <label>Gender<span>*</span></label>
                      <select required style="width: 100% !important;" class="floating-select" v-model="addFamilyModel.gender">
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </select>
                      <span class="highlight"></span>
                      <div class="ib-custom-select"></div>
                    </div>
                  </div>
                  <div class="in-mbody-footer">
                    <button class="ib-btn-primary ib-btn-hover mr-3" type="Submit">Save</button>
                  </div>
                </form>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import loading from '@/components/Loading/Loading'
import moment from "moment";
import { mask } from 'vue-the-mask';
import _ from 'lodash';

export default {
  name: 'PolicyServicingCreate',
  components: {
    loading,
    Datepicker
  },
  data() {
    return {
      showLoader: true,
      EndorsementDetail: {},
      beneficiary: {},
      quotation_id: this.$route.params.quotation_id,
      id: this.$route.params.id,
      type: this.$route.params.type,
      beneficiaryRelations: {},
      beneficiaryData: {},
      beneficiaryFormData: [],
      beneficiaries: {},
      stepThreeDynamicDocuments: {},
      AcquisitionDynamicFields: {},
      OldAcquisitionDynamicFields: {},
      stepThreeDocumentSections : [],
      stepOneDynamicFields: {},
      OldstepOneDynamicFields: {},
      section: {},
      familyMembers: {},
      deleteSpouseIds: [],
      deleteChildIds: [],
      saveFamilyMembers: [],
      stepOneErrors: [],
      isBeneficiaryFound: true,
      modelFamily: {
        spouse: {},
        child: {}
      },
      addFamilyModel:{
        gender : '',
        name : '',
        relation : '',
        dob : '',
        cnic: '',
        passport : '',
        id: '',
        is_new: 1
      },
      familyConfig: {},
      selectedMember: {},
      addFamily: false,
      showFamily: false,
      values: {
        reason : ''
      },
      childCount: 0,
      spouseCount: 0,
      familyDobValidation : '',
      OldBeneficiary : {}
    };
  },
  directives: { mask },
  created: function () {
    const self = this;
    self.getEndorsements();
    self.getBeneficiariesData();
  },
  computed: {
    date() {
      return moment().format('YYYY-MM-DD');
    }
  },
  methods: {
    validateBeneficiaryMobileNo(event) {
      const self = this;
      let val = event.target.value;

      if(val != "") {
        const usingSplit = val.split('');
        let issue = false;

        let i = 0;
        for (i; i < 4; i++) {
          if(usingSplit[i] === '0') {
            issue = true;
            break;
          }
        }

        if (issue) {
          self.beneficiaryData['mobile_no'] = '+92';
        }
      }
    },
    formatDBDate (dbDate, type) {
      if(dbDate == '' || dbDate == null || dbDate == undefined) {
        return '';
      } else {
        if(type == 'field') {
          var parts = dbDate.split('-'); //'20-04-2021'
          var newDate = new Date(parts[0], parts[1] -1, parts[2]);
        }
        if(type == 'beneficiary') {
          var parts = dbDate.split('-'); //'2021-04-20'
          var newDate = new Date(parts[0], parts[1] -1, parts[2]);
        }
        //let newDate = new Date(Date.parse(dbDate));
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = Math.abs(newDate.getFullYear());
        let newDateString = month + '-' + date + '-' + year;
        let selectedDate = moment(newDateString, "M-D-YYYY").toDate();
        return selectedDate;
      }
    },
    removeStepThreeUploadedImage(index, fieldName) {
      const self = this;
      self.stepThreeDynamicDocuments[fieldName].splice(index, 1);
      self.stepThreeDocumentSections.push({test: 'test'});
      self.stepThreeDocumentSections.splice(-1,1);
    },
    uploadStepThreeImages(e, field_name, max_limit) {
      let self = this;
      if(e.target.files.length > 0) {
        var selectedFiles = e.target.files;
      } else {
        return false;
      }

      if(field_name == 'signature_document') {
        self.stepThreeDynamicDocuments[field_name] = [];
      }
      for (let i = 0; i < selectedFiles.length; i++) {
        if(selectedFiles[i]['type'].split('/')[0] != 'image') {
          $toast.error('Only image files are accepted', { position: 'top-right' });
        } else if (selectedFiles[i].size > 5000000) {
          $toast.error('Upload file less than 5Mb', { position: 'top-right' });
          return false;
        } else {
          if(self.stepThreeDynamicDocuments[field_name].length >= max_limit) {
            $toast.error('Only ' + max_limit + ' files allowed', { position: 'top-right' });
          } else {
            self.stepThreeDynamicDocuments[field_name].push(selectedFiles[i]);
          }
        }
      }

      self.stepThreeDocumentSections.push({test: 'test'});
      self.stepThreeDocumentSections.splice(-1,1);
    },
    priceFormatter(price) {
      return new Intl.NumberFormat('en-PK').format(price);
    },
    AddFamilyModal: function () {
      const self = this;
      self.showFamily = true;
      self.addFamilyModel = {
        gender : '',
          name : '',
          relation : '',
          dob : '',
          cnic: '',
          passport : '',
          id: Math.floor(Math.random() * 999) + '_fm',
          is_new: 1
      }
      self.familyDobValidation = '';
    },
    async getPolicyBeneficiary(){
      const self = this;
      await axios.get('customer/policy_beneficiaries?policy_id='+self.quotation_id).then(function (resp) {
        if(resp.data.code == 200) {
          if (resp.data.data.length == 0){
            $toast.error('No Beneficiary Found Against This Policy', { position: 'top-right' });
          }else{
            self.beneficiaries['id']  = resp.data.data[0].id;
            self.OldBeneficiary = resp.data.data[0];
            self.isBeneficiaryFound = false;
          }
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.response) {
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
     getPolicyFamilyMembers(){
      const self = this;
       axios.get('customer/policy_family_members?policy_id='+self.quotation_id).then(function (resp) {
        if(resp.data.code == 200) {
          self.familyMembers = resp.data.data;
          self.familyMembers.forEach(element => {
            if (element.relation == 'child'){
              self.childCount = childCount + 1;
            }else{
              self.spouseCount = spouseCount + 1;
            }
          });
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.response) {
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    async getBeneficiariesData() {
      const self = this;
      await axios.get('customer/beneficiary_relations').then(function (resp) {
        if(resp.data.code == 200) {
          self.beneficiaryRelations = resp.data.data.beneficiary_relations;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.response) {
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    async getEndorsements() {
      var self = this;
      self.showLoader = true;
      if (self.type == 'beneficiary'){
        self.getPolicyBeneficiary();
        await axios.get('endorsement_beneficiary_fields?endorsement_type_id=' + self.id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.EndorsementDetail = resp.data.data;
            self.beneficiary = resp.data.data.beneficiary;
            self.beneficiaryData.fields.forEach(field => {
              if (field.beneficiary_detail_field == 'relationship'){
                self.beneficiaries['relation_id'] = '';
              }
              self.beneficiaries[field.beneficiary_detail_field] = '';
            });

          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }

      if (self.type == 'family'){
        self.getPolicyFamilyMembers();
        await axios.get('endorsement_family_fields?endorsement_type_id=' + self.id + '&customer_quotation_id=' + self.quotation_id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {

            self.familyConfig = resp.data.data;
              self.familyConfig.allowed_fields.spouse.forEach(field =>{
                self.modelFamily.spouse[field] = ''
              });

              self.familyConfig.allowed_fields.child.forEach(field => {
                self.modelFamily.child[field] = ''
              });
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }

      if (self.type == 'general_acquisition'){

        let formData = new FormData();
        formData.append('customer_quotation_id', self.quotation_id);
        formData.append('endorsement_type_id', self.id);
        await axios.post('/customer/endorsement/acquisition_fields', formData).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            let keys = Object.keys(resp.data.data.sections);

            self.AcquisitionDynamicFields = resp.data.data.sections[keys[0]];
            self.OldAcquisitionDynamicFields = resp.data.data.sections[keys[0]];
            self.stepThreeDocumentSections = resp.data.data.documents;
            Object.entries(self.AcquisitionDynamicFields.custom_fields).forEach(([key, field]) => {
              if (field.type == 'date'){
                self.stepOneDynamicFields[field.field_name] = self.formatDBDate(field.selected_value, 'field');
                self.OldstepOneDynamicFields[field.field_name] = self.formatDBDate(field.selected_value, 'field');
              }else{
                self.stepOneDynamicFields[field.field_name] = field.selected_value;
                self.OldstepOneDynamicFields[field.field_name] = field.selected_value;
              }
            });

              Object.entries(self.stepThreeDocumentSections).forEach(([key, field]) => {
                self.stepThreeDynamicDocuments[field.field_name] = [];
              });
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }

      self.showLoader = false;
    },
    cancellationRequest: function (e){
      e.preventDefault();
      const self = this;
      var formData = new FormData();
      formData.append('customer_quotation_id', self.quotation_id);
      formData.append('reason', self.values.reason);
       axios.post('customer/endorsement/policy_cancellation_requests', formData).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          $toast.success(resp.data.message, { position: 'top-right' });
          self.$router.push({ name: 'Endorsements', params: {id: self.quotation_id } });
          return false;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });

    },
    BeneficiaryRequest: function (e){
      e.preventDefault();
      const self = this;
      let arr = [];
      arr.push(self.beneficiaries)
      let formData = new FormData();
      formData.append('customer_quotation_id', self.quotation_id);
      formData.append('endorsement_type_id', self.id);
      formData.append('beneficiaries', JSON.stringify(arr));
      formData.append('reason', self.values.reason);

      axios.post('store_endorsement_beneficiary', formData).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          $toast.success(resp.data.message, { position: 'top-right' });
          self.$router.push({ name: 'Endorsements', params: {id: self.quotation_id } });
          return false;
        } else {
          if(resp.data.errors != undefined) {
            resp.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          }else{
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    ShowEditForm: function (familyId){
      const self = this;
      self.addFamily = true;
      self.selectedMember = self.familyMembers.filter(x => x.id == familyId)[0];
      if (self.selectedMember.relation == 'spouse'){
        Object.entries(self.modelFamily.spouse).forEach(([key, value]) => {
          self.modelFamily.spouse[key] = self.selectedMember[key];
        });
        self.modelFamily.spouse['id'] = self.selectedMember.id;
        self.modelFamily.spouse['relation'] = 'spouse';

      }else{
        Object.entries(self.modelFamily.child).forEach(([key, value]) => {
          self.modelFamily.child[key] = self.selectedMember[key];
        });
        self.modelFamily.child['relation'] = 'child';
        self.modelFamily.child['id'] = self.selectedMember.id;
      }
    },
    CloseModal: function (){
      const self = this;
      self.addFamily = false;
      self.showFamily = false;
    },
    SubmittedRequest(){
      const self = this;
      self.$router.push({ name: 'SubmittedRequest', params: {id: self.quotation_id } });
    },
    EndorsementForm(id){
      let self = this;
      self.$router.push({ name: 'EndorsementRequestForm', params: {id: id, quotation_id: self.quotation_id } });
    },
    saveFamily: function (e){
      e.preventDefault();
      const self = this;
      self.familyDobValidation = '';

      if (self.selectedMember.relation != '') {
        let maxDate = '';
        let minDate = '';
        if(self.selectedMember.relation == 'spouse') {
          let selectedDate = moment(self.modelFamily.spouse.dob, "DD-MMM-YYYY");
          maxDate = moment(self.familyConfig.family.spouse_max_age, "YYYY-MM-DD");
          minDate = moment(self.familyConfig.family.spouse_min_age, "YYYY-MM-DD");
          if (selectedDate > minDate) {
            $toast.error('Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY') , { position: 'top-right' });
            return false;
          }
          if (selectedDate < maxDate) {
            $toast.error('Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY') , { position: 'top-right' });
            return false;
          }
        }
        if(self.selectedMember.relation == 'child') {
          let selectedDate = moment(self.modelFamily.child.dob, "DD-MMM-YYYY");

          maxDate = moment(self.familyConfig.family.child_max_age, "YYYY-MM-DD");
          minDate = moment(self.familyConfig.family.child_min_age, "YYYY-MM-DD");
          if (selectedDate > minDate) {
            $toast.error('Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY') , { position: 'top-right' });
            return false;
          }
          if (selectedDate < maxDate) {
            $toast.error('Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY') , { position: 'top-right' });
            return false;
          }
        }


      }

      let index = self.saveFamilyMembers.findIndex(x => x.id == self.selectedMember.id);
      let oldIndex = self.familyMembers.findIndex(x => x.id == self.selectedMember.id);

      self.familyMembers.splice(oldIndex, 1);
      if (self.selectedMember.relation == 'spouse'){
        self.modelFamily.spouse.dob = self.modelFamily.spouse.dob != undefined && self.modelFamily.spouse.dob != '' ? moment(self.modelFamily.spouse.dob).format("YYYY-MM-DD") : '';

        self.familyMembers.push(self.modelFamily.spouse);
      }else{
        self.modelFamily.child.dob = self.modelFamily.child.dob != undefined && self.modelFamily.child.dob != '' ? moment(self.modelFamily.child.dob).format("YYYY-MM-DD") : '';

        self.familyMembers.push(self.modelFamily.child);
      }

      if (index < 0){
          if (self.selectedMember.relation == 'spouse'){
            self.modelFamily.spouse.dob = self.modelFamily.spouse.dob != undefined && self.modelFamily.spouse.dob != '' ? moment(self.modelFamily.spouse.dob).format("YYYY-MM-DD") : '';

            self.saveFamilyMembers.push(self.modelFamily.spouse);
          }else{
            self.modelFamily.child.dob = self.modelFamily.child.dob != undefined && self.modelFamily.child.dob != '' ? moment(self.modelFamily.child.dob).format("YYYY-MM-DD") : '';

            self.saveFamilyMembers.push(self.modelFamily.child);
          }

      }else{
        self.saveFamilyMembers.splice(index, 1);

        if (self.selectedMember.relation == 'spouse'){
          self.modelFamily.spouse.dob = self.modelFamily.spouse.dob != undefined && self.modelFamily.spouse.dob != '' ? moment(self.modelFamily.spouse.dob).format("YYYY-MM-DD") : '';

          self.saveFamilyMembers.push(self.modelFamily.spouse);
        }else{
          self.modelFamily.child.dob = self.modelFamily.child.dob != undefined && self.modelFamily.child.dob != '' ? moment(self.modelFamily.child.dob).format("YYYY-MM-DD") : '';

          self.saveFamilyMembers.push(self.modelFamily.child);
        }
      }
      self.CloseModal();


    },
    saveNewFamily: function (e) {
      e.preventDefault();
      const self = this;
      let index = self.saveFamilyMembers.findIndex(x => x.id == self.addFamilyModel.id);

      if (self.addFamilyModel.relation == 'spouse'){
        if (self.familyConfig.family.has_spouse == 0){
          $toast.error('No Spouse Allowed', { position: 'top-right' });
          return false;
        }

        if (self.familyConfig.family.no_of_spouse > self.spouseCount){
          self.spouseCount = self.spouseCount + 1;
        }else{
          $toast.error('Max Spouse Allowed ' + self.familyConfig.family.no_of_spouse , { position: 'top-right' });
          return false;
        }
      }else{
        if (self.familyConfig.family.has_child == 0){
          $toast.error('No Child Allowed', { position: 'top-right' });

          return false;
        }
        if (self.familyConfig.family.no_of_child > self.childCount){
          self.childCount = self.childCount + 1;
        }else{
          $toast.error('Max Child Allowed ' + self.familyConfig.family.no_of_child , { position: 'top-right' });
          return false;
        }
      }

      if (self.addFamilyModel.relation != '') {
        let selectedDate = moment(self.addFamilyModel.dob, "YYYY-MM-DD");
        let maxDate = '';
        let minDate = '';
        if(self.addFamilyModel.relation == 'spouse') {

          maxDate = moment(self.familyConfig.family.spouse_max_age, "YYYY-MM-DD");
          minDate = moment(self.familyConfig.family.spouse_min_age, "YYYY-MM-DD");

        }
        if(self.addFamilyModel.relation == 'child') {
          maxDate = moment(self.familyConfig.family.child_max_age, "YYYY-MM-DD");
          minDate = moment(self.familyConfig.family.child_min_age, "YYYY-MM-DD");
        }

        if (selectedDate > minDate) {
          self.familyDobValidation =  'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')

          return false;
        }
        if (selectedDate < maxDate) {
          self.familyDobValidation =  'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
          return false;
        }
      }

      if (index < 0){
        self.saveFamilyMembers.push(self.addFamilyModel);
      }else{
        self.saveFamilyMembers.splice(index, 1);
        self.saveFamilyMembers.push(self.addFamilyModel);
      }
      self.showFamily = false;
    },
    rmsaveNewFamily: function (id){
      const self = this;
      let index = self.saveFamilyMembers.findIndex(x => x.id == id);
        self.saveFamilyMembers.splice(index, 1);

    },
    showUpdateForm: function (id) {
      const self = this;
      let member = self.saveFamilyMembers.filter(x => x.id == id);
      self.addFamilyModel = member[0];
      self.showFamily = true;

    },
    updatesaveNewFamily: function (id) {
      const self = this;

      let index = self.saveFamilyMembers.findIndex(x => x.id == id);

      self.saveFamilyMembers.splice(index, 1);
      self.saveFamilyMembers.push(self.addFamilyModel);

    },
    UpdateFamily: function (e) {
      e.preventDefault();
      const self = this;
      let formData = new FormData();
      let spouse = [];
      let child = [];

      formData.append('customer_quotation_id', self.quotation_id);
      formData.append('endorsement_type_id', self.id);
      if (self.familyConfig.family.family_action == 'add'){
        self.saveFamilyMembers.forEach(element =>{

          delete element.id;
          delete element.is_new;
          element.dob = element.dob != undefined && element.dob != '' ? moment(element.dob).format("YYYY-MM-DD") : '';
          if (element.relation == 'child'){
            child.push(element);
          }else{
            spouse.push(element);
          }
        });
        if (child.length > 0){
          formData.append('child', JSON.stringify(child));
        }
        if (spouse.length > 0){
          formData.append('spouse', JSON.stringify(spouse));

        }
      }
      if (self.familyConfig.family.family_action == 'update'){

        self.saveFamilyMembers.forEach(element =>{
          if (element.relation == 'child'){
            child.push(element);
          }else{
            spouse.push(element);
          }
        });

        if (child.length > 0){
          formData.append('child', JSON.stringify(child));
        }
        if (spouse.length > 0){
          formData.append('spouse', JSON.stringify(spouse));

        }
      }
      if(self.familyConfig.family.family_action == 'remove'){
        self.deleteSpouseIds.forEach(element =>{
          formData.append('delete_spouse_ids[]', element);
        });
        self.deleteChildIds.forEach(element =>{
          formData.append('delete_child_ids[]', element);
        });
      }

      formData.append('reason', self.values.reason);

      axios.post('store_endorsement_family',formData).then(function (resp) {
        if(resp.data.code == 200) {
          $toast.success(resp.data.message, { position: 'top-right' });
          self.$router.push({ name: 'Endorsements', params: {id: self.quotation_id } });

        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.response) {
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    setDeletedId: function (id, type) {
      const self = this;
      if (type == 'spouse'){
        self.deleteSpouseIds.push(id);
      }else{
        self.deleteChildIds.push(id);
      }
      document.getElementById("member_"+id).style.display = "none";
    },
    validateStepOneMobileNo: function(event, field_name) {
      const self = this;
      let val = event.target.value;
      if(val != "") {
        const usingSplit = val.split('');
        let issue = false;
        let i = 0;
        for (i; i < 4; i++) {
          if(usingSplit[i] == '0') {
            issue = true;
            break;
          }
        }

        if (issue) {
          self.stepOneDynamicFields[field_name] = '+92';
          document.getElementById("mobile_no").value = "+92";
          console.log(self.stepOneDynamicFields);
        }
      }
    },
    verifyStepOneEmail: function(event, field_name) {
      const self = this;

      self.stepOneErrors = [];
      let email = event.target.value;
      if(email == '') {
        return false;
      }

      const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      let result = re.test(String(email).toLowerCase());
      if(!result) {
        self.stepOneErrors.push({
          field: field_name,
          message: 'Invalid Email'
        });
      }
    },
    generalAcquisitionForm: function (e) {
      e.preventDefault();
      const self = this;
      let stepThreeDynamicFieldsFinal = {};
      let todayDate = moment().startOf('day');
        Object.entries(self.AcquisitionDynamicFields.custom_fields).forEach(([key2, field]) => {
          if(field.type.toLowerCase() == 'date') {
            let selectedDate = moment(self.stepOneDynamicFields[field.field_name], "DD-MMM-YYYY");
            let maxDate = moment(field.max_date, "YYYY-MM-DD");
            let minDate = moment(field.min_date, "YYYY-MM-DD");

            if (field.field_name == 'cnic_issuance' || field.field_name == 'cnic_issuancedate'){

                if (selectedDate > todayDate) {
                  $toast.error('Cnic issue date must be less than or equal to ' + moment(todayDate).format('DD-MMM-YYYY'), { position: 'top-right' });
                  return false;
                }
              }

              if (field.field_name == 'cnic_expiry' || field.field_name == 'cnic_expirydate' ){
                if (selectedDate < todayDate) {
                  $toast.error('Cnic expiry date must be greater than or equal to ' + moment(todayDate).format('DD-MMM-YYYY'), { position: 'top-right' });
                  return false;
                }
              }
              if (field.field_name == 'departure_date'){
                if (selectedDate < minDate) {
                  $toast.error('Departure Date date must be greater than or equal to ' + moment(minDate).format('DD-MMM-YYYY'), { position: 'top-right' });
                  return false;
                }
              }
            if (field.field_name == 'date_of_birth'){

              if (selectedDate < minDate) {
                $toast.error('The Date of Birth must be between ' + field.min_date + ' and ' +field.max_date, { position: 'top-right' });
                return false;
              }
              if (selectedDate > maxDate) {
                $toast.error('The Date of Birth must be between ' + field.min_date + ' and ' +field.max_date, { position: 'top-right' });
                return false;
              }
            }
              stepThreeDynamicFieldsFinal[field.field_name] = moment(self.stepOneDynamicFields[field.field_name]).format("YYYY-MM-DD");
              stepThreeDynamicFieldsFinal['old_'+field.field_name] = moment(field.selected_value).format("YYYY-MM-DD");
            } else {
              stepThreeDynamicFieldsFinal[field.field_name] = self.stepOneDynamicFields[field.field_name];
              stepThreeDynamicFieldsFinal['old_' + field.field_name] = field.selected_value;
            }
        })
      let formData = new FormData();
      formData.append('customer_quotation_id', self.quotation_id);
      formData.append('endorsement_type_id', self.id);
      formData.append('reason', self.values.reason);
      Object.entries(stepThreeDynamicFieldsFinal).forEach(([key, value]) => {
        formData.append(key, value);
      });

        Object.entries(self.stepThreeDynamicDocuments).forEach(([key, value]) => {
          if (key == 'signature_document') {
            let doc = value[0];
            formData.append('signature', doc);
          } else {
            value.forEach(element => {
              formData.append(key + '[]', element);
            });
          }
        });
      axios.post('customer/endorsement/form_data', formData).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          $toast.success(resp.data.message, { position: 'top-right' });
          self.$router.push({ name: 'Endorsements', params: {id: self.quotation_id } });
          return false;
        } else {
          if(resp.data.errors != undefined) {
            resp.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          }else{
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }
      }).catch(function (error) {
        self.showLoader = false;

        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    }
  }
};
</script>

<style scoped>
.active {
  display: block !important;
}
.tab-pane {
  display: none;
}
.claim-doc-icon p {
  font-family: "Avenir Medium";
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c505d;
  margin-bottom: 0px;
}
.claim-data-icon img {
  margin: 0 auto;
}
/* .claim-data-icon {
  width: 121px;
  height: 124px;
  border-radius: 10px;
  border: solid 1px #e5e5e5;
  background-color: #ffffff;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  display: flex !important;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
} */
.claim-data-icon img{
  width: 40px;
  margin-top: 8px;
}
/* .claim-data-icon:not(:nth-of-type(1)) {
  margin-left: 15px;
  margin-right: 15px;
} */
.claim-row-sub-heading {
  font-family: "Avenir Book";
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  padding-left: 20px;
  color: #ef7c94;
  color: #ef7c94 !important;
}
.jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
  border: solid 1px transparent;
  color: #fff !important;
  height: 61px;
  border-radius: 31px;
  background-color: #def3f7;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
  border: solid 1px var(--primary-color);
  background-color: var(--primary-color);
  color: #fff !important;
  height: 61px;
  border-radius: 31px;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.jbl-nav-tabs .nav-item .nav-link {
  color: #5b6770;
}
.jbl-nav-tabs {
  border-radius: 31px;
  box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  background-color: #def3f7;
  border: 0;
  font-family: "Avenir Medium";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
  margin: 20px 0 10px 15px;
  /* padding-top: 1px;
  padding-bottom: 1px; */
}
table > tbody > tr, .data-row {
  margin: 10px 0;
  padding: 20px 30.7px 20px 15px;
  border-radius: 10px;
  box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  border: solid 1px #dedada;
  background-color: #ffffff;
}
.data-row .action-area {
  text-align: right;
}
.data-row .action-area i {
  width: 7.9px;
  height: 14.6px;
  color: #5b6770;
}
.claim-sub-heading {
  width: 100%;
  min-height: 54px;
  margin: 20px 0px;
  padding: 16px;
  border-radius: 7px;
  /* border: dotted 2px #3d9cbd; */
  border: dashed 2px #3d9cbd;
  background-color: rgba(61, 156, 189, 0.03);
  font-family: "Avenir Heavy";
  font-size: 16px;
  /* font-weight: 900; */
  text-align: left;
  color: #ef7c94 !important;
}
.data-row .claim-sub-heading {
  font-family: "Avenir Heavy";
  font-size: 16px;
  /* font-weight: 900; */
  text-align: left;
  color: #ef7c94 !important;
}
.data-row .claim-row-sub-desc {
  color: #5b6770;
}
.data-row .status-danger {
  background-color: rgba(30, 203, 16, 0.09);
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  color: #1ecb10;
  letter-spacing: normal;
}
.data-row .status {
  padding: 6px 24px;
  border-radius: 6px;
  font-family: "Avenir Medium";
}
.data-row .claim-row-data {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.37;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}
.data-row .claim-row-heading {
  font-family: "Avenir Medium";
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}

.input-placeholder:focus ~ label, .input-placeholder:valid ~label {
  font-size:11px;
  left:10px;
  top:-10px;
}
.input-placeholder:valid ~label {
  color:green;
}
.input-placeholder:focus:invalid ~label {
  color:red;
}
.jbl-data-img{
  width: 100px;
  height: 65px;
  margin-right: .6rem;
}
.table.table-borderless td {
  padding: 1rem 0rem;
}
@media (max-width:576px) {
  nav.nav-tabs.jbl-nav-tabs{
    margin: 0 auto;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
    border: solid 1px transparent;
    height: 2.2rem;
  }

  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
    border: solid 1px #007bff;
    height: 2.2rem;
  }
  .jbl-nav-tabs {
    font-size: 14px;
  }
  .nav-item .nav-link{
    padding: 0.5rem .5rem;
  }
}
dd.claim-row-data {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
  padding-left: 20px;
}
.col-md-3 p.claim-row-data:nth-of-type(2) {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
  padding-left: 20px;
}

.claim-data-icon img {
  margin: 0 auto;
}
.claim-car-icon {
  width: 165.3px;
  height: 122.9px;
  border-radius: 10px;
  border: solid 1px #e5e5e5;
  background-color: #ffffff;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  display: flex !important;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  margin: 1rem !important;
  padding-left: 10px !important;
  padding-left: 10px !important;
  overflow: hidden;
}
.claim-car-icon img{
  width: 100%;
  height: auto;
  margin-top: 8px;
}
.claim-car-icon:not(:nth-of-type(1)) {
  margin-left: 15px;
  margin-right: 15px;
}
button:hover, button:focus{
  border: 1px solid transparent !important;
  outline: transparent !important;
  box-shadow: transparent !important;
  text-decoration: none !important;
}
.multistep-box label{
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PolicyServicing/Create.vue